import {atom } from "recoil";
import { PageAtomKeys } from "../ConstantKeys";

import { Page } from "../../CommonUtils/Enums";

export type PreferenceCardType ={
    heading:string,
    description:string,
    img:string,
    moduleTypeNames:Array<string>,
    shouldDisplay:boolean,
}

export type PreferenceCardAtomType=Array<PreferenceCardType>;

export const preferenceCardAtomDefaultValue = [
    {heading:'IG 12 Server',description:'Installs all the default pods required for IG 12 Server',img:"/AppInstaller/Images/modishicon.png",moduleTypeNames:["Notification Service","Global Application Service","Configuration Application Service","Configuration Central","Post Processing Smart Cook Service","Post Processing Import Export Service","Post Processing Config Sync Service","Post Processing Check Service","Reporting Services"],shouldDisplay:false,},
    {heading:'IG Client App',description:'Installs all the default pods required to run a 12UX terminal, Kiosk12 or KDS 12',img:"/AppInstaller/Images/modishicon.png",moduleTypeNames:["IG Terminal App"],shouldDisplay:false,},
    {heading:'À la carte',description:'Allows you to Pick and Choose many pods as needed',img:"/AppInstaller/Images/mothershiplogo.png",moduleTypeNames:["Interface ServerIS"],shouldDisplay:true,}
];

export const preferenceCardAtom=atom<PreferenceCardAtomType>({
    key :PageAtomKeys.preferenceCardAtom,
    default : preferenceCardAtomDefaultValue,
})


export type ProfileDetailsType ={
    Id:number
    Name: string,
    ModuleTypeId: number,
    ModuleTypeName: string,
    ModuleTypeDetails: {
        HasSublicense: boolean,
        Description: string,
    },
    ModuleConfiguration: Array<any>,
    HasLicenseValidation: boolean,
    Count: number,
    PackageInfo: {
        PackageCreatedDate: string
        PackageVersion: string
    }
    TerminalAppTypeName: string;
    AppType: string;
}

export type ProfileDetailsAtomType=Array<ProfileDetailsType>;

export const profileDetailsAtomDefaultValue = [];

export const profileDetailsAtom=atom<ProfileDetailsAtomType>({
    key :PageAtomKeys.profileDetailsAtom,
    default : profileDetailsAtomDefaultValue,
})



export type RegistrationTokenAtomType = {
    registrationKey:string,token:string,
}

export const registrationTokenAtomDefaultValue={registrationKey:"",token:""}

export const registrationTokenAtom = atom <RegistrationTokenAtomType>({
    key:PageAtomKeys.registrationTokenAtom,
    default : registrationTokenAtomDefaultValue,
});




export type ConfigurationListItemType = {
    ConfigurationId: number,
    Name: string,
    value: string,
    label: string,
}

export type ConfigurationListAtomType = Array<ConfigurationListItemType>

export const ConfigurationListAtomDefaultValue = [{ConfigurationId:0,Name:'Default',value:'Default',label:'Default'}];

export const configurationListAtom = atom <ConfigurationListAtomType>({
    key : PageAtomKeys.configurationListAtom,
    default:ConfigurationListAtomDefaultValue
});


export type ModuleItemType = {
    Name: string,
    ModuleTypeId: number,
    LicenseProfileName: string,
    LicenseProfileId: number,
    AppType?: string,
    TerminalAppTypeName?: string
}

export type ConfigurationItemType={
    Name: string,
    Content: string,
    Version: number,
    CreatedDateTime: string,
    ModifiedDateTime: string,
    Key: string,
    ContentType: string,
    GroupName: string,
    PodName: string
}


export type JsonDataAtomtype={
    DownloadUrl?: string,
    BlobFolder?: string,
    RegistrationUrl?: string,
    Path?: string,
    AppCentral?: string,
    LAS?: string,
    Terminal?: string,
    IISProxy?: string,
    VirtualMachine?: string,
    RemoveRevelationServices?: string,
    License?: {
        RegisteredLicenseId?:string,
        CdlsApiUrl: string,
        CustomerId: string,
        InstanceId: string,
        LicenseKey: string,
        Modules: Array<ModuleItemType>
        
    },
    Configuration?: Array<ConfigurationItemType>
}

export const jsonDataAtomDefaultValue={
	DownloadUrl: "",
    BlobFolder: "Drivers",
	RegistrationUrl: "https://cdls.agilysys.com/registerdevice",
	Path: "C:/appcentral",
	AppCentral: "true",
	LAS: "false",
	Terminal: "false",
	IISProxy: "false",
	VirtualMachine: "false",
	RemoveRevelationServices: "false",
	License: {
        RegisteredLicenseId:"",
		CdlsApiUrl: "",
		CustomerId: "",
		InstanceId: "",
		LicenseKey: "",
		Modules: [
		]
	},
	"Configuration": [		
	]
}

const tokenDefaultSelector = {
    token: ""
}

export const jsonDataAtom=atom<JsonDataAtomtype>({
    key:PageAtomKeys.jsonDataAtom,
    default:jsonDataAtomDefaultValue,
})


export const pageNameAtom=atom<string>({
    key : PageAtomKeys.pageNameAtom,
    default: Page.DeviceRegistration
})

export const tokenAtom=atom<any>({
    key :PageAtomKeys.token,
    default:tokenDefaultSelector
})